import http from '@/http'
const URL = '/admin/settings/tasks/change-status'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const listContacts = async (obj) => {
  const list = (await http.get(URL + `/${obj.id}/contacts`, { params: obj.params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const save = (payload) => {
  return http.post(URL, payload)
}

export const countParticipants = (payload) => {
  return http.post('/admin/settings/tasks/count-participants', payload)
}

export default {
  list,
  listContacts,
  show,
  save,
  countParticipants
}
